import { Field, GenericFieldHTMLAttributes } from 'redux-form';
import { FieldThroughFormControlProps } from 'shared/components/FormControl/FormControl';

export default Field as new () => Field<
  // Attributes consumed by the FormControl
  FieldThroughFormControlProps &
    // Attributes consumed by the input
    // TODO: unfortunately generics don't work here, so any is used to custom attributes passed to input
    GenericFieldHTMLAttributes &
    any
>;
